module.exports = __webpack_public_path__ + "static/2-6e2a1157eb976dc5f272cdeac97d7584.jpg";